import store from '@/store';

const WEB_AI_WIDGET_APP_CODE_NAME = 'webaiwidgetmgr';
const WEB_AI_WIDGET_FEATURE_FLAGS = [
  'rollout.online_presence.web_ai_widget',
];
const FEATURE_FLAGS_TIMEOUT = 5000;
const DASHBOARD_ROUTE = { name: 'dashboard', replace: true };

const areFeatureFlagsLoaded = () => store.getters['BusinessStore/featureFlagsLoaded'];

const hasWebAiWidgetFeature = () => {
  const hasFeature = store.getters['BusinessStore/hasFeature'];
  return WEB_AI_WIDGET_FEATURE_FLAGS.some((featureName) => hasFeature(featureName));
};

const isWebAiWidgetInstalled = async () => {
  await store.dispatch('MainMenuStore/fetchApplicationsMenuItemsForce');
  const externalApps = store.getters['MainMenuStore/externalApplications'] || [];
  return externalApps.some((app) => app.app_code_name === WEB_AI_WIDGET_APP_CODE_NAME);
};

const createFeatureFlagsPromise = () => {
  if (areFeatureFlagsLoaded()) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    const unwatch = store.watch(
      (state, getters) => getters['BusinessStore/featureFlagsLoaded'],
      (loaded) => {
        if (loaded) {
          unwatch();
          resolve();
        }
      },
    );
  });
};

const createTimeoutPromise = () => new Promise((_, reject) => {
  setTimeout(reject, FEATURE_FLAGS_TIMEOUT);
});

const webAiWidgetRouteGuard = async (to, from, next) => {
  try {
    await Promise.race([
      createFeatureFlagsPromise(),
      createTimeoutPromise(),
    ]);

    const [isFeatureEnabled, isAppInstalled] = await Promise.all([
      Promise.resolve(hasWebAiWidgetFeature()),
      isWebAiWidgetInstalled(),
    ]);

    if (isFeatureEnabled || isAppInstalled) {
      next();
      return;
    }

    next(DASHBOARD_ROUTE);
  } catch {
    next(DASHBOARD_ROUTE);
  }
};

export default webAiWidgetRouteGuard;
